import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../ui/Button';
import Icon from '../ui/Icon';
import { ICONS } from '../ui/icon-map';
import { usePermissions } from '../hooks/usePermissions';
import { viewAsRole } from '../utils/viewAsRole';

/**
 * On every page while an admin looks at the app as a role (owner's permissions plan, 3 Oct 2026: "شوف البرنامج كأنك
 * الدور ده ... مابيغيّرش حاجة"): whose eyes these are, that nothing is saved, and the way back.
 */
export default function ViewAsBanner() {
    const { viewingAs } = usePermissions();
    const navigate = useNavigate();
    if (!viewingAs) return null;
    return (
        <div role="status" className="sticky top-0 z-40 mb-3 rounded-lg border-2 border-amber-400 bg-amber-50 px-4 py-2 flex flex-wrap items-center gap-x-3 gap-y-1">
            <Icon glyph={ICONS.eye} size="sm" tone="warning" />
            <span className="text-sm font-semibold text-amber-900">You are seeing the app as "{viewingAs.name}"</span>
            <span className="text-xs text-amber-800">
                its menus, pages, tabs and buttons · the role is not changed by looking · <b>you are still the Admin: a
                button you press here acts for real</b> (Ejar, saves, deletes) · a few parts still check the Admin role
                itself and show as for the Admin (The Engine's admin tools, Collections, Refunds, the calculator,
                Monthly's admin tools, every user's activity, Edit a car, the automatic registration cards) until they
                get their own permission in the next phases
            </span>
            <Button size="sm" variant="secondary" className="ml-auto" onClick={() => { viewAsRole.clear(); navigate('/admin/roles'); }}>
                Exit
            </Button>
        </div>
    );
}
